import { Signal } from "@angular/core";
import { StoreBatch } from "../../storage/data-store/model/master-data/store-batch";
import { StoreTrial } from "../../storage/data-store/model/master-data/store-trial";
import { StoreTrialPhase } from "../../storage/data-store/model/master-data/store-trial-phase";
import { getByIds } from "../record.function";
import { StoreTrialPhaseType } from "../../storage/data-store/model/master-data/store-trial-phase-type";

export function getBatchesForTrial(trial: StoreTrial, batches: Signal<Record<string, StoreBatch>>): StoreBatch[] {
  const batchesForTrial: StoreBatch[] = getByIds(batches, trial.batchIds);
  return batchesForTrial;
}

export function getFirstInterimTrialPhase(trial: StoreTrial): StoreTrialPhase | null {
  for (const trialPhase of trial.phases) {
    if (trialPhase.type.name === StoreTrialPhaseType.Interim && trialPhase.number === 2) {
      return trialPhase;
    }
  }
  return null;
}

export function getSecondInterimTrialPhase(trial: StoreTrial): StoreTrialPhase | null {
  for (const trialPhase of trial.phases) {
    if (trialPhase.type.name === StoreTrialPhaseType.Interim && trialPhase.number === 3) {
      return trialPhase;
    }
  }
  return null;
}

export function getFinalTrialPhase(trial: StoreTrial): StoreTrialPhase | null {
  for (const trialPhase of trial.phases) {
    if (trialPhase.type.name === StoreTrialPhaseType.Final) {
      return trialPhase;
    }
  }
  return null;
}
